export default __webpack_public_path__ + "static/media/Collab8.762f6aaf.png";